import {Pipe, PipeTransform} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {IUser} from '@shared/interfaces/user';
import {HtmlSanitizerService} from '@core/services/html-sanitizer.service';

@Pipe({
    name: 'highlightMention',
    pure: false,
})
export class HighlightMentionPipe implements PipeTransform {

    constructor(private htmlSanitizer: HtmlSanitizerService) {
    }

    transform(value: string, args?: IUser[]): SafeHtml {
        if (!value) {
            return '';
        }

        // First, sanitize the input value to remove any XSS attempts
        let sanitizedValue = this.htmlSanitizer.stripAllHtml(value);

        // Then highlight mentions with sanitized user names
        if (args && args.length > 0) {
            args.forEach((user: IUser) => {
                if (user.FULL_NAME) {
                    // Sanitize the user's full name to prevent XSS through username
                    const safeName = this.htmlSanitizer.sanitizeName(user.FULL_NAME);

                    if (sanitizedValue.includes(`@${safeName}`)) {
                        // Use a safe replacement with only a span tag for styling
                        const escapedName = this.escapeRegExp(safeName);
                        const regex = new RegExp(`@${escapedName}`, 'g');
                        sanitizedValue = sanitizedValue.replace(regex, `<span class="mention-mark">${safeName}</span>`);
                    }
                }
            });
        }

        // Finally, sanitize the result allowing only safe tags (span for mentions)
        return this.htmlSanitizer.sanitizeUserContent(sanitizedValue);
    }

    /**
     * Escape special regex characters in a string
     */
    private escapeRegExp(text: string): string {
        return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

}
